import React, { useEffect, useState } from "react";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchfreelancerProfile,
  fetchOpenTalentDashboard,
  fetchPostJobs,
} from "../../redux/features/find-a-job/actions/authAction";
import Loader from "../../components/loader";
import JobPostDetails from "../../components/Modals/common/jobpost/JobPostDetails";
import FreeTrialModal from "../../components/Modals/find-a-job/FreeTrialModal";
import { useNavigate } from "react-router-dom";
import { getProfile, setProfile } from "../../utils/pip";
import { coachPaths } from "../../routes/coach";

const Dashboard = () => {
  const {
    isLoading,
    subLoading,
    freelancersJobs,
    dashboardData,
    freelancerProfileData,
  } = useSelector((state) => state.freelancer.auth);
  const [jobListDetails, setJobListDetails] = useState({});
  const [showFreeTrial, setShowFreeTrial] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data;
      if (!data) return;

      const existing = getProfile("freelancer") || {};
      const merged = {
        ...existing,
        ...data,
        full_name:
          data.full_name ||
          existing.full_name ||
          `${data.first_name || ""} ${data.last_name || ""}`.trim(),
        first_name:
          data.first_name || existing.first_name || data.full_name || "",
        last_name: data.last_name || existing.last_name || "",
      };

      setProfile("freelancer", merged);
    });
    dispatch(fetchPostJobs());
    dispatch(fetchOpenTalentDashboard());
  }, [dispatch]);

  useEffect(() => {
    const flag = localStorage.getItem("freelancer_free_trial_modal");
    if (!flag) return;
    const storedProfile = getProfile("freelancer") || {};
    const talentType =
      freelancerProfileData?.open_talent?.talent_type ||
      storedProfile?.open_talent?.talent_type ||
      "FREELANCER";
    const isJobSeeker = talentType === "JOB_SEEKER";
    if (isJobSeeker) {
      localStorage.removeItem("freelancer_free_trial_modal");
      return;
    }
    setShowFreeTrial(true);
    localStorage.removeItem("freelancer_free_trial_modal");
  }, [freelancerProfileData]);

  if (isLoading || subLoading) {
    return <Loader />;
  };
  return (
    <>
      {showFreeTrial && (
        <div
          className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-dialog-centered ct_modal-dialog"
            style={{ maxWidth: "480px" }}
          >
            <div className="modal-content">
              <div className="modal-header border-0 p-0 pb-2">
                <button
                  type="button"
                  className="btn-close ct_close_position_right12"
                  onClick={() => setShowFreeTrial(false)}
                ></button>
              </div>
              <FreeTrialModal
                onContinue={() => setShowFreeTrial(false)}
                buttonText="Close"
              />
            </div>
          </div>
        </div>
      )}
      <FreelancerLayout>
        <div class="ct_px_40 mt-4">
          <div className="row">
            <div className="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0">
              <div class="mb-4">
                <h4 class="mb-0 ct_fs_20 ct_fw_600 mb-2">
                  Welcome Back, Alex!
                </h4>
                <p class="ct_grey_text mb-0">
                  Your Freelance Journey Starts Here, Track and Manage
                  Seamlessly
                </p>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_py_10_px_13">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_14 ct_darkblue_text mb-3">
                          Application Submitted
                        </p>
                        <h4 class="ct_fs_24_new ct_darkblue_text">
                          {dashboardData?.total_jobs_submitted || "0"}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_1.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2">
                      <li class="ct_fs_12 ct_orange_text">
                        <svg
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32114)">
                            <path
                              d="M7.03156 16.2038L15.3574 8.03125"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32114">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(11.418 0.6875) rotate(45.5323)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        0%
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        {dashboardData?.today_jobs_submitted || "0"}{" "}
                        Application submitted today
                      </li>
                    </ul>
                    {/* <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                      <a href="#" class="ct_yellow_link ct_fs_14">
                        View Report
                      </a>
                      <a href="#">
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                            stroke="#FFB703"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </div> */}
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_py_10_px_13">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_14 ct_darkblue_text mb-3">
                          Application Reviewed
                        </p>
                        <h4 class="ct_fs_24_new ct_darkblue_text ">
                          {dashboardData?.total_jobs_reviewed || "0"}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_2.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2">
                      <li class="ct_fs_12 ct_sky_blue_text">
                        0%
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32145)">
                            <path
                              d="M5.73231 8.00261L15.8359 13.8359"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32145">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(21.8555 8.07031) rotate(120)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        {dashboardData?.today_jobs_reviewed || "0"}{" "}
                        Application reviewed today
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_py_10_px_13">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_14 ct_darkblue_text mb-3">
                          Interview Schedule
                        </p>
                        <h4 class="ct_fs_24_new ct_darkblue_text">
                          {dashboardData?.total_jobs_scheduled || "0"}{" "}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_3.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2">
                      <li class="ct_fs_12 ct_orange_text">
                        <svg
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32114)">
                            <path
                              d="M7.03156 16.2038L15.3574 8.03125"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32114">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(11.418 0.6875) rotate(45.5323)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        0%
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        {dashboardData?.today_jobs_scheduled || "0"} interview
                        scheduled today
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="ct_outline_bg ct_py_26_px_16">
                <div className="d-flex align-items-center justify-content-between gap-3 mb-3 ct_flex_col_767">
                  <div class="d-flex align-items-center gap-3 ">
                    <img
                      src="../assets/img/wallet_icon.svg"
                      alt=""
                      class="ct_flex_shrink_0"
                    />
                    <h4 class="mb-0 ct_fs_16">Courses/ Workshop</h4>
                  </div>
                  <div class="d-flex align-items-center gap-3 ">
                    <div className="ct_search">
                      <input
                        className="form-control ct_input ct_h_32 ct_border_radius_8 bg-transparent ct_input_ps_40"
                        placeholder="Search"
                      />
                      <img
                        src="../assets/img/search-2-line.svg"
                        className="ct_left_icon_search"
                      />
                    </div>
                    <button className="ct_yellow_btn ct_outline_light_grey ct_h_32 ct_border_radius_8 px-3 ct_white_nowrap">
                      See All
                    </button>
                  </div>
                </div>

                <div className="table-responsive ct_freelance_table">
                  <table className="table ">
                    <thead>
                      <tr>
                        <th>Instructor</th>
                        <th>Course Name</th>
                        <th>Progress</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div class="d-flex align-items-center gap-3">
                            <img
                              src="../assets/img/user_22.jpeg"
                              class="ct_img_40"
                            />
                            <div>
                              <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                Nuray Aksoy
                              </h5>
                              <p class="mb-0 ct_grey_text">Product Manager</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="ct_fs_14 mb-1">Time Management</p>
                          <p className="ct_fs_12 mb-0 ct_grey_text">
                            Aug 21 - Sep 04
                          </p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <div class="progress ct_custom_progress ct_flex_1">
                              <div
                                class="progress-bar"
                                role="progressbar"
                                style={{ width: "25%" }}
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <span className="ct_white_nowrap">30%</span>
                          </div>
                        </td>
                        <td>
                          <span
                            class="ct_publish_badge ct_darkblue_text px-2 ct_w_fit_content bg-transparent"
                            style={{ borderColor: "#E1E4EA" }}
                          >
                            <svg
                              className="me-1"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12ZM6.6 6V3H5.4V7.2H9V6H6.6Z"
                                fill="#FB8500"
                              />
                            </svg>
                            In Progress
                          </span>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              class="px-0"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a class="dropdown-item" href="#">
                                  View Details
                                </a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                >
                                  Cancelled
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="d-flex align-items-center gap-3">
                            <img
                              src="../assets/img/user_22.jpeg"
                              class="ct_img_40"
                            />
                            <div>
                              <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                Nuray Aksoy
                              </h5>
                              <p class="mb-0 ct_grey_text">Product Manager</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="ct_fs_14 mb-1">Time Management</p>
                          <p className="ct_fs_12 mb-0 ct_grey_text">
                            Aug 21 - Sep 04
                          </p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <div class="progress ct_custom_progress ct_flex_1">
                              <div
                                class="progress-bar"
                                role="progressbar"
                                style={{ width: "25%" }}
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <span className="ct_white_nowrap">30%</span>
                          </div>
                        </td>
                        <td>
                          <span
                            class="ct_publish_badge px-2 ct_w_fit_content ct_darkblue_text bg-transparent"
                            style={{ borderColor: "#E1E4EA" }}
                          >
                            <svg
                              className="me-1"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12ZM6.6 6V3H5.4V7.2H9V6H6.6Z"
                                fill="#FB8500"
                              />
                            </svg>
                            In Progress
                          </span>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              class="px-0"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a class="dropdown-item" href="#">
                                  View Details
                                </a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                >
                                  Cancelled
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="d-flex align-items-center gap-3">
                            <img
                              src="../assets/img/user_22.jpeg"
                              class="ct_img_40"
                            />
                            <div>
                              <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                Nuray Aksoy
                              </h5>
                              <p class="mb-0 ct_grey_text">Product Manager</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="ct_fs_14 mb-1">Time Management</p>
                          <p className="ct_fs_12 mb-0 ct_grey_text">
                            Aug 21 - Sep 04
                          </p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <div class="progress ct_custom_progress ct_flex_1">
                              <div
                                class="progress-bar"
                                role="progressbar"
                                style={{ width: "25%" }}
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <span className="ct_white_nowrap">30%</span>
                          </div>
                        </td>
                        <td>
                          <span
                            class="ct_publish_badge ct_darkblue_text px-2 ct_w_fit_content bg-transparent"
                            style={{ borderColor: "#E1E4EA" }}
                          >
                            <svg
                              className="me-1"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12ZM5.4018 8.4L9.6438 4.1574L8.7954 3.309L5.4018 6.7032L3.7044 5.0058L2.856 5.8542L5.4018 8.4Z"
                                fill="#219EBC"
                              />
                            </svg>
                            Completed
                          </span>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              class="px-0"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a class="dropdown-item" href="#">
                                  View Details
                                </a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                >
                                  Cancelled
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="d-flex align-items-center gap-3">
                            <img
                              src="../assets/img/user_22.jpeg"
                              class="ct_img_40"
                            />
                            <div>
                              <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                Nuray Aksoy
                              </h5>
                              <p class="mb-0 ct_grey_text">Product Manager</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="ct_fs_14 mb-1">Time Management</p>
                          <p className="ct_fs_12 mb-0 ct_grey_text">
                            Aug 21 - Sep 04
                          </p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <div class="progress ct_custom_progress ct_flex_1">
                              <div
                                class="progress-bar"
                                role="progressbar"
                                style={{ width: "25%" }}
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <span className="ct_white_nowrap">30%</span>
                          </div>
                        </td>
                        <td>
                          <span
                            class="ct_publish_badge px-2 ct_w_fit_content bg-transparent ct_darkblue_text"
                            style={{ borderColor: "#E1E4EA" }}
                          >
                            <svg
                              className="me-1"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12ZM5.4018 8.4L9.6438 4.1574L8.7954 3.309L5.4018 6.7032L3.7044 5.0058L2.856 5.8542L5.4018 8.4Z"
                                fill="#219EBC"
                              />
                            </svg>
                            Completed
                          </span>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              class="px-0"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a class="dropdown-item" href="#">
                                  View Details
                                </a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                >
                                  Cancelled
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> */}
              <div className="row ct_mt_10 mb-4">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div className="ct_outline_bg ct_p_20 ct_border_radius_10 h-100">
                    <h3 className="ct_fs_20_new ct_darkblue_text mb-2">
                      Book Your First Coaching Session
                    </h3>
                    <p
                      className="ct_grey_text mb-0"
                      style={{ maxWidth: "404px" }}
                    >
                      Stay aligned, stay accountable. Access your coach profile,
                      track your sessions, and get expert feedback when you need
                      it.
                    </p>
                    <div className="ct_mt_20">
                      <button className="ct_yellow_btn ct_darkblue_btn px-5" onClick={() => navigate(coachPaths?.WebinarLandingPage)}>
                        Explore CoachHub
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div className="ct_outline_bg ct_p_20 ct_border_radius_10 h-100">
                    <h3 className="ct_fs_20_new ct_darkblue_text mb-2">
                      You’re All Caught Up!
                    </h3>
                    <p
                      className="ct_grey_text mb-0"
                      style={{ maxWidth: "404px" }}
                    >
                      Explore workshop or attend a webinar that makes a
                      different to sharpen your mindset, skills and client-ready
                      confidence.
                    </p>
                    <div className="ct_mt_20">
                      <button className="ct_yellow_btn  px-5" onClick={() => navigate(coachPaths?.WebinarData, {
                        state: { data: "workshop" },
                      })}>
                        Explore Events
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="ct_mt_20">
                <div className=" ct_mb_30 d-flex align-items-center justify-content-between gap-3">
                  <h4 className="ct_fs_20_new ct_darkblue_text mb-0">
                    Job Recommendations
                  </h4>
                  <a className="ct_dark_blue_link">View All</a>
                </div>
                <div className="row mb-4">
                  {freelancersJobs?.length != 0 &&
                    freelancersJobs?.map((item) => (
                      <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4 mt-4 mb-xl-0">
                        <div className="ct_outline_bg ct_pt_23_37_17 h-100 d-grid">
                          <div>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <img src="../assets/img/LogoRLP_logo.png" />
                              <span
                                className="ct_badge ct_yellow_text"
                                style={{ borderColor: "var(--yellow)" }}
                              >
                                {item?.candidate_availability || ""}
                              </span>
                            </div>
                            <div className="ct_mt_20">
                              <h5 className="ct_fs_16 mb-2 ct_darkblue_text">
                                {item?.job_title || ""}{" "}
                              </h5>
                              <div class="d-flex align-items-center gap-3">
                                <p class="ct_grey_text  ct_fs_14 mb-0 ">
                                  {item?.industry || ""}{" "}
                                </p>
                                <p class="ct_grey_text ct_fs_14 mb-0 ct_dot_5 ct_flex_shrink_0"></p>
                                <p class="ct_grey_text ct_fs_14 mb-0 ct_white_nowrap">
                                  {item?.candidate_location || ""}
                                </p>
                              </div>
                            </div>
                            <div className="ct_mt_20">
                              <div class="progress ct_custom_progress ct_flex_1">
                                <div
                                  class="progress-bar"
                                  role="progressbar"
                                  style={{ width: "25%" }}
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                              <p className="mt-2">
                                <span className="ct_darksky_blue_text">
                                  43%
                                </span>{" "}
                                Match with your profile
                              </p>
                            </div>
                          </div>
                          <div className="mt-auto pt-5">
                            <button
                              className="ct_yellow_btn ct_outline_darksky ct_h_34 px-4"
                              data-bs-target="#ct_job_details_modal"
                              data-bs-toggle="modal"
                              onClick={() => setJobListDetails(item)}
                            >
                              Apply Now
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div> */}
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 mb-4 mt-4 mb-lg-0">
              <div>
                <div>
                  <h4 className="ct_fs_20 ct_mb_30">Profile Strength</h4>
                  <div className="ct_outline_bg h-100 ct_py_20_px_27 ct_border_radius_10">
                    <div className="text-center">
                      <img
                        src="../assets/img/Avatar_11.png"
                        className="ct_img_56"
                      />
                    </div>
                    <ul className="mt-5">
                      <li>
                        <div className="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p className="mb-0 ct_darkblue_text">
                            Profile Completed
                          </p>
                          {/* <a className="mb-0 ct_yellow_link">Complete Now</a> */}
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <div class="progress ct_custom_progress ct_flex_1">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              style={{ width: "100%" }}
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <span className="ct_white_nowrap">100%</span>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div className="d-flex align-items-center gap-2 justify-content-between mb-2">
                          <p className="mb-0 ct_darkblue_text">
                            Profile Strength
                          </p>
                          <a className="mb-0 ct_yellow_link">Complete Now</a>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <div class="progress ct_custom_progress ct_flex_1">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              style={{ width: "0%" }}
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <span className="ct_white_nowrap">0%</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="ct_mt_60">
                  <h4 className="ct_fs_20 ct_mb_30">Skill Development</h4>
                  <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10">
                    <p className="ct_fs_16 ct_darkblue_text">
                      Recommended Courses
                    </p>
                    <ul>
                      <li>
                        <div class="course-card">
                          <div>
                            <h6 class="ct_fs_16 mb-3">Mobile App Design</h6>
                            <div class="d-flex align-items-center gap-3">
                              <p class="ct_grey_text  ct_fs_14 mb-0">
                                Design System{" "}
                              </p>
                              <p class="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                              <p class="ct_grey_text ct_fs_14 mb-0">
                                Prototype
                              </p>
                            </div>
                            <div className="ct_mt_20">
                              <a href="#" class="ct_yellow_link">
                                Continue Course
                              </a>
                            </div>
                          </div>

                          <div class="progress-circle progress-circle_orange">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div
                          class="course-card"
                          style={{
                            backgroundColor: "hsl(199deg 64% 73% / 5%)",
                          }}
                        >
                          <div>
                            <h6 class="ct_fs_16 mb-3">Mobile App Design</h6>
                            <div class="d-flex align-items-center gap-3">
                              <p class="ct_grey_text  ct_fs_14 mb-0">
                                Design System{" "}
                              </p>
                              <p class="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                              <p class="ct_grey_text ct_fs_14 mb-0">
                                Prototype
                              </p>
                            </div>
                            <div className="ct_mt_20">
                              <a href="#" class="ct_yellow_link">
                                Continue Course
                              </a>
                            </div>
                          </div>

                          <div class="progress-circle progress-circle_lightsky">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div class="course-card">
                          <div>
                            <h6 class="ct_fs_16 mb-3">Mobile App Design</h6>
                            <div class="d-flex align-items-center gap-3">
                              <p class="ct_grey_text  ct_fs_14 mb-0">
                                Design System{" "}
                              </p>
                              <p class="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                              <p class="ct_grey_text ct_fs_14 mb-0">
                                Prototype
                              </p>
                            </div>
                            <div className="ct_mt_20">
                              <a href="#" class="ct_yellow_link">
                                Continue Course
                              </a>
                            </div>
                          </div>

                          <div class="progress-circle progress-circle_yellow">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                    </ul>

                    <div className="mt-5">
                      <h4 className="ct_fs_16 ct_darkblue_text mb-3">
                        Skill Enhancement Insights
                      </h4>
                      <ul className="d-flex align-items-center gap-3  flex-wrap ct_custom_scroll ct_para_scroll">
                        <li>
                          <span
                            className="ct_badge ct_white_nowrap ct_py_7_px_16 ct_border_radius_10"
                            style={{ borderColor: "#EEEEEE" }}
                          >
                            Design System
                          </span>
                        </li>
                        <li>
                          <span
                            className="ct_badge ct_white_nowrap ct_py_7_px_16 ct_border_radius_10"
                            style={{ borderColor: "#EEEEEE" }}
                          >
                            UX Writing
                          </span>
                        </li>
                        <li>
                          <span
                            className="ct_badge ct_white_nowrap ct_py_7_px_16 ct_border_radius_10"
                            style={{ borderColor: "#EEEEEE" }}
                          >
                            Flow Chart
                          </span>
                        </li>
                        <li>
                          <span
                            className="ct_badge ct_white_nowrap ct_py_7_px_16 ct_border_radius_10"
                            style={{ borderColor: "#EEEEEE" }}
                          >
                            Web App Design
                          </span>
                        </li>
                        <li>
                          <span
                            className="ct_badge ct_py_7_px_16 ct_border_radius_10"
                            style={{ borderColor: "#EEEEEE" }}
                          >
                            Prototyping
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {jobListDetails && (
          <JobPostDetails
            id="ct_job_details_modal"
            jobListDetails={jobListDetails}
            freelancersJobs={freelancersJobs}
          />
        )}
      </FreelancerLayout >
    </>
  );
};

export default Dashboard;
